module.exports = __webpack_public_path__ + "static/sergey-8a5dccf21f14d79a174dcc0e47f9fa3f.png";